import { phdScannerApiAxios } from "../lib/axios-interceptor";

export interface OpportunityStats {
  total_count: number;
  last_month_count: number;
  percentage_change: number;
}

export interface CustomUsersCount {
  count: number;
}

export interface RecentActivity {
  id: string;
  title: string;
  description: string;
  type: 'opportunity' | 'user' | 'role';
  created_at: number;
  created_by: string;
}

export interface RecentActivitiesResponse {
  activities: RecentActivity[];
}

export const DashboardService = {
  async getOpportunityStats(): Promise<OpportunityStats> {
    const response = await phdScannerApiAxios.get("/api/saas/opportunity-stats");
    return response.data;
  },

  async getCustomUsersCount(): Promise<CustomUsersCount> {
    const response = await phdScannerApiAxios.get("/api/saas/custom-users-count");
    return response.data;
  },

  async getRecentActivities(): Promise<RecentActivitiesResponse> {
    const response = await phdScannerApiAxios.get("/api/saas/recent-activities");
    return response.data;
  }
}; 